module.exports = __webpack_public_path__ + "img/training.4843eed7.svg";